import { Box } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

import { ColorWidget } from 'components/Theme/ColorWidget';

export const Route = createFileRoute('/colors/$id')({
  component: () => {
    return (
      <Box>
        <ColorWidget />
      </Box>
    );
  },
});
